import React, { Component } from "react";
import SEO from "react-seo-component";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import news from "../articles/news";

class Section extends Component {
  render() {
    return (
      <React.Fragment>
        <SEO
          title={
            "QikTruck - South Africa's Premier On-Demand Truck & Driver Hire Service | Affordable Transport Solutions"
          }
          titleTemplate={"QikTruck"}
          titleSeparator={`-`}
          description={
            "Transform your logistics with QikTruck's on-demand truck and driver hire service. Instant quotes, reliable drivers, insured transport for furniture, equipment, construction materials and more across South Africa."
          }
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"https://qiktruck.co.za"}
          twitterUsername={"qiktrucksa"}
        />

        {/* Hero Section */}
        <section className="hero-section bg-primary text-white py-5">
          <Container>
            <Row className="align-items-center min-vh-50">
              <Col lg={6} md={12}>
                <h1 className="display-4 font-weight-bold mb-4 text-white">
                  Move Anything, Anywhere in South Africa
                </h1>
                <p className="lead mb-4 text-white">
                  QikTruck connects you with professional drivers and reliable
                  vehicles for all your transportation needs. From furniture
                  moves to construction materials - get instant quotes and book
                  trusted transport services.
                </p>
                <div className="d-flex flex-wrap gap-3 mb-4">
                  <Button color="dark" size="lg" href="/truck-hire">
                    <i className="mdi mdi-truck mr-2"></i>
                    Get Instant Quote
                  </Button>
                  <Button
                    color="outline-light"
                    size="lg"
                    href="/partner-drivers"
                    style={{ margin: "10px 10px" }}
                  >
                    <i className="mdi mdi-account-plus mr-2"></i>
                    Become a Driver
                  </Button>
                </div>
                <div className="hero-features">
                  <span className="badge badge-light mr-3">
                    <i className="mdi mdi-check-circle mr-1"></i>Instant Quotes
                  </span>
                  <span className="badge badge-light mr-3">
                    <i className="mdi mdi-shield-check mr-1"></i>Fully Insured
                  </span>
                  <span className="badge badge-light">
                    <i className="mdi mdi-clock mr-1"></i>24/7 Support
                  </span>
                </div>
              </Col>
              <Col lg={6} md={12} className="text-center">
                <div className="hero-image p-4">
                  <img
                    src={require("../../assets/images/D0E1D7.png")}
                    alt="QikTruck delivery vehicle"
                    className="img-fluid rounded "
                    style={{ maxHeight: "400px" }}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Statistics Section */}
        <section className="stats-section py-5 bg-light">
          <Container>
            <Row className="text-center">
              <Col lg={3} md={6} className="mb-4">
                <div className="stat-item">
                  <h2 className="display-4 text-primary font-weight-bold">
                    10K+
                  </h2>
                  <p className="lead">Successful Deliveries</p>
                </div>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <div className="stat-item">
                  <h2 className="display-4 text-primary font-weight-bold">
                    5000+
                  </h2>
                  <p className="lead">Trusted Drivers</p>
                </div>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <div className="stat-item">
                  <h2 className="display-4 text-primary font-weight-bold">9</h2>
                  <p className="lead">Provinces Covered</p>
                </div>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <div className="stat-item">
                  <h2 className="display-4 text-primary font-weight-bold">
                    4.8★
                  </h2>
                  <p className="lead">Customer Rating</p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Services Section */}
        <section className="services-section py-5">
          <Container>
            <Row className="justify-content-center mb-5">
              <Col lg={8} className="text-center">
                <h2 className="display-5 font-weight-bold mb-3">
                  Complete Transport Solutions for Every Need
                </h2>
                <p className="lead text-muted">
                  Whether you're moving home, transporting business goods, or
                  need construction materials delivered, QikTruck has the right
                  vehicle and driver for your job.
                </p>
              </Col>
            </Row>
            <Row>
              <Col lg={3} md={6} className="mb-4">
                <Card className="h-100 border-0 shadow-sm hover-lift">
                  <CardBody className="text-center p-4">
                    <div className="service-icon mb-3">
                      <i
                        className="mdi mdi-clock-outline text-primary"
                        style={{ fontSize: "3rem" }}
                      ></i>
                    </div>
                    <h4 className="font-weight-bold mb-3">Instant Quotation</h4>
                    <p className="text-muted mb-4">
                      Get accurate pricing in seconds with our smart quotation
                      system. No waiting, no hidden fees - transparent pricing
                      upfront.
                    </p>
                    <ul className="list-unstyled text-left">
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>
                        Real-time pricing
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>
                        Multiple vehicle options
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>
                        Distance-based rates
                      </li>
                    </ul>
                    <Button color="primary" className="mt-3" href="/truck-hire">
                      Book Now
                    </Button>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Card className="h-100 border-0 shadow-sm hover-lift">
                  <CardBody className="text-center p-4">
                    <div className="service-icon mb-3">
                      <i
                        className="mdi mdi-truck text-primary"
                        style={{ fontSize: "3rem" }}
                      ></i>
                    </div>
                    <h4 className="font-weight-bold mb-3">
                      Professional Drivers
                    </h4>
                    <p className="text-muted mb-4">
                      Our vetted drivers are licensed, insured, and experienced.
                      Earn money with your vehicle or find reliable transport.
                    </p>
                    <ul className="list-unstyled text-left">
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>
                        Background checked
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>Fully
                        insured services
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>Short
                        & long distance
                      </li>
                    </ul>
                    <Button
                      color="primary"
                      className="mt-3"
                      href="/partner-drivers"
                    >
                      Join as Driver
                    </Button>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Card className="h-100 border-0 shadow-sm hover-lift">
                  <CardBody className="text-center p-4">
                    <div className="service-icon mb-3">
                      <i
                        className="mdi mdi-source-branch text-primary"
                        style={{ fontSize: "3rem" }}
                      ></i>
                    </div>
                    <h4 className="font-weight-bold mb-3">Developer API</h4>
                    <p className="text-muted mb-4">
                      Integrate QikTruck's transport services into your
                      applications. Build custom solutions with our robust API.
                    </p>
                    <ul className="list-unstyled text-left">
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>
                        RESTful API
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>
                        Real-time tracking
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>
                        Comprehensive docs
                      </li>
                    </ul>
                    <Button color="primary" className="mt-3" href="/developers">
                      View API Docs
                    </Button>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Card className="h-100 border-0 shadow-sm hover-lift">
                  <CardBody className="text-center p-4">
                    <div className="service-icon mb-3">
                      <i
                        className="mdi mdi-shield-check text-primary"
                        style={{ fontSize: "3rem" }}
                      ></i>
                    </div>
                    <h4 className="font-weight-bold mb-3">
                      Insurance Coverage
                    </h4>
                    <p className="text-muted mb-4">
                      Complete peace of mind with comprehensive insurance
                      coverage. Your goods are protected throughout the entire
                      journey.
                    </p>
                    <ul className="list-unstyled text-left">
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>
                        Comprehensive coverage
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>Goods
                        in transit protection
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success mr-2"></i>
                        Third-party liability
                      </li>
                    </ul>
                    <Button color="primary" className="mt-3" href="/insurance">
                      Learn More
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Vehicle Types Section */}
        <section className="vehicles-section py-5 bg-light">
          <Container>
            <Row className="justify-content-center mb-5">
              <Col lg={8} className="text-center">
                <h2 className="display-5 font-weight-bold mb-3">
                  Choose Your Perfect Vehicle
                </h2>
                <p className="lead text-muted">
                  From small bakkies to large trucks, we have the right vehicle
                  for your cargo size and budget.
                </p>
              </Col>
            </Row>
            <Row>
              <Col lg={3} md={6} className="mb-4">
                <div className="vehicle-card text-center p-4 bg-white rounded shadow-sm">
                  <i
                    className="mdi mdi-car text-primary mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h5 className="font-weight-bold">Small Bakkie</h5>
                  <p className="text-muted small">
                    Perfect for furniture, appliances
                  </p>
                  <div className="text-primary font-weight-bold">From R180</div>
                </div>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <div className="vehicle-card text-center p-4 bg-white rounded shadow-sm">
                  <i
                    className="mdi mdi-truck text-primary mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h5 className="font-weight-bold">Medium Truck</h5>
                  <p className="text-muted small">
                    Ideal for office moves, equipment
                  </p>
                  <div className="text-primary font-weight-bold">From R280</div>
                </div>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <div className="vehicle-card text-center p-4 bg-white rounded shadow-sm">
                  <i
                    className="mdi mdi-truck-trailer text-primary mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h5 className="font-weight-bold">Large Truck</h5>
                  <p className="text-muted small">
                    Construction materials, bulk goods
                  </p>
                  <div className="text-primary font-weight-bold">From R450</div>
                </div>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <div className="vehicle-card text-center p-4 bg-white rounded shadow-sm">
                  <i
                    className="mdi mdi-motorbike text-primary mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <h5 className="font-weight-bold">Courier Bike</h5>
                  <p className="text-muted small">Documents, small packages</p>
                  <div className="text-primary font-weight-bold">From R50</div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* How It Works Section */}
        <section className="how-it-works py-5">
          <Container>
            <Row className="justify-content-center mb-5">
              <Col lg={8} className="text-center">
                <h2 className="display-5 font-weight-bold mb-3">
                  How QikTruck Works
                </h2>
                <p className="lead text-muted">
                  Getting your goods transported is as easy as 1-2-3 with
                  QikTruck's streamlined process.
                </p>
              </Col>
            </Row>
            <Row>
              <Col lg={4} md={12} className="mb-4">
                <div className="step-item text-center">
                  <div
                    className="step-number bg-primary text-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <span className="font-weight-bold">1</span>
                  </div>
                  <h4 className="font-weight-bold mb-3">Enter Details</h4>
                  <p className="text-muted">
                    Tell us what you need to move, pickup and delivery
                    locations, and when you need it done. Our smart system
                    calculates the best price instantly.
                  </p>
                </div>
              </Col>
              <Col lg={4} md={12} className="mb-4">
                <div className="step-item text-center">
                  <div
                    className="step-number bg-primary text-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <span className="font-weight-bold">2</span>
                  </div>
                  <h4 className="font-weight-bold mb-3">Choose & Book</h4>
                  <p className="text-muted">
                    Select your preferred vehicle type and driver. Pay securely
                    online and get confirmation with driver details and
                    tracking.
                  </p>
                </div>
              </Col>
              <Col lg={4} md={12} className="mb-4">
                <div className="step-item text-center">
                  <div
                    className="step-number bg-primary text-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <span className="font-weight-bold">3</span>
                  </div>
                  <h4 className="font-weight-bold mb-3">Track & Receive</h4>
                  <p className="text-muted">
                    Monitor your delivery in real-time with GPS tracking. Get
                    notifications and rate your experience when delivery is
                    complete.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section py-5 bg-light">
          <Container>
            <Row className="justify-content-center mb-5">
              <Col lg={8} className="text-center">
                <h2 className="display-5 font-weight-bold mb-3">
                  What Our Customers Say
                </h2>
                <p className="lead text-muted">
                  Join thousands of satisfied customers who trust QikTruck for
                  their transport needs.
                </p>
              </Col>
            </Row>
            <Row>
              <Col lg={3} md={6} className="mb-4">
                <Card className="border-0 shadow-sm h-100">
                  <CardBody className="text-center p-4">
                    <div className="mb-3">
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                    </div>
                    <p className="text-muted mb-4">
                      "QikTruck made my office relocation so easy! The driver
                      was professional, punctual, and handled our equipment with
                      care. Highly recommended!"
                    </p>
                    <h6 className="font-weight-bold">Sarah M.</h6>
                    <small className="text-muted">
                      Business Owner, Cape Town
                    </small>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Card className="border-0 shadow-sm h-100">
                  <CardBody className="text-center p-4">
                    <div className="mb-3">
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                    </div>
                    <p className="text-muted mb-4">
                      "As a construction company, we need reliable transport for
                      materials. QikTruck delivers every time - on schedule and
                      at great prices."
                    </p>
                    <h6 className="font-weight-bold">Mike R.</h6>
                    <small className="text-muted">
                      Construction Manager, Johannesburg
                    </small>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Card className="border-0 shadow-sm h-100">
                  <CardBody className="text-center p-4">
                    <div className="mb-3">
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                    </div>
                    <p className="text-muted mb-4">
                      "The instant quote feature is amazing! I got a fair price
                      immediately and the whole booking process was seamless.
                      Will definitely use again."
                    </p>
                    <h6 className="font-weight-bold">Linda K.</h6>
                    <small className="text-muted">Homeowner, Durban</small>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={3} md={6} className="mb-4">
                <Card className="border-0 shadow-sm h-100">
                  <CardBody className="text-center p-4">
                    <div className="mb-3">
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                      <i className="mdi mdi-star text-warning"></i>
                    </div>
                    <p className="text-muted mb-4">
                      "Fantastic service for my furniture delivery! The driver
                      helped with loading and was very careful with fragile
                      items. Great customer service too."
                    </p>
                    <h6 className="font-weight-bold">James T.</h6>
                    <small className="text-muted">
                      Retail Manager, Pretoria
                    </small>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* News Section */}
        <section className="news-section py-5">
          <Container>
            <Row className="justify-content-center mb-5">
              <Col lg={8} className="text-center">
                <h2 className="display-5 font-weight-bold mb-3">
                  Latest News & Updates
                </h2>
                <p className="lead text-muted">
                  Stay informed about QikTruck's latest features, partnerships,
                  and industry insights.
                </p>
              </Col>
            </Row>
            <Row>
              {news.slice(0, 4).map((article, index) => (
                <Col lg={3} md={6} key={index} className="mb-4">
                  <Card className="border-0 shadow-sm h-100 hover-lift">
                    <div
                      className="card-img-top"
                      style={{
                        backgroundImage: `url(https://media.qiktruck.co.za/${article.image})`,
                        height: "200px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                    <CardBody>
                      <div className="mb-2">
                        <span className="badge badge-primary mr-2">
                          {article.category}
                        </span>
                        <small className="text-muted">
                          <i className="mdi mdi-clock-outline mr-1"></i>
                          {article.date}
                        </small>
                      </div>
                      <h5 className="font-weight-bold mb-3">
                        <a
                          href={`/articles/${article?.pathname?.toLowerCase()}`}
                          className="text-dark text-decoration-none"
                        >
                          {article.heading}
                        </a>
                      </h5>
                      <p className="text-muted">{article.copy}</p>
                      <a
                        href={`/articles/${article?.pathname?.toLowerCase()}`}
                        className="btn btn-outline-primary btn-sm"
                      >
                        Read More <i className="mdi mdi-arrow-right ml-1"></i>
                      </a>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <Row>
              <Col className="text-center">
                <Button color="outline-primary" href="/news">
                  View All News <i className="mdi mdi-arrow-right ml-2"></i>
                </Button>
              </Col>
            </Row>
          </Container>
        </section>

        {/* CTA Section */}
        <section className="cta-section py-5 bg-primary text-white">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={8}>
                <h2 className="display-5 font-weight-bold mb-3 text-white">
                  Ready to Move with QikTruck?
                </h2>
                <p className="lead mb-4">
                  Join thousands of satisfied customers and experience South
                  Africa's most reliable transport service.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
